module.exports = "# Intro Video  \n\nYouTube: 0MKIR2myq7U\n\n## Notes\nSara and Ian introduce the Drawing activity (1:21).\n\n# Sizzle\n\n## Content\n\n### Activity 1: Drawing!\n\n## Notes\n\n&nbsp;\n\n# Instructions\n\n## Content\n\n### Activity Instructions:\n* Draw a picture of the people you might be with in an emergency.\n* Points for trying your best!\n\n## Notes\n\n&nbsp;\n"


//////////////////
// WEBPACK FOOTER
// ./programs/epsHybridPrimaries/sections/30_classActivity/level3_drawing.md
// module id = 1580
// module chunks = 2